import { hostBridge } from '@publicala/delfino';
import type { GoToPositionPayload } from '@publicala/delfino';
import type { VuexStore } from '../types';

let navigationStore: VuexStore | null = null;

/**
 * Configure dependencies for navigation commands.
 *
 * @param store - Vuex store
 */
export function configureNavigationCommands(store: VuexStore): void {
    navigationStore = store;
}

/**
 * Register navigation commands that Volpe implements.
 * The Host calls these methods.
 */
export function registerNavigationCommands(): void {
    if (!navigationStore) {
        console.warn('[NavigationCommands] store not configured. Call configureNavigationCommands first.');
        return;
    }

    const store = navigationStore;

    hostBridge.registerNavigationCommands({
        /**
         * Handle go back command from host.
         * Closes smart zoom or the reader.
         */
        goBack: async (): Promise<void> => {
            store.dispatch('closeSmartZoomOrVolpe');
        },

        /**
         * Navigate to a specific position.
         *
         * @param payload - Target position
         */
        goToPosition: async (payload: GoToPositionPayload): Promise<void> => {
            const position = payload?.position;
            if (!position) return;

            if (store.getters.isPdf && position.startPage !== undefined) {
                store.dispatch('goToPage', { page: position.startPage });
            } else if (store.getters.isEpub) {
                if (position.epubLocationStartCfi) {
                    store.dispatch('setLastLocation', {
                        chapterHref: position.epubChapter,
                        cfi: position.epubLocationStartCfi,
                    });
                }
            } else if (store.getters.isAudiobook) {
                if (position.currentTrack !== undefined) {
                    store.dispatch('setLastLocation', {
                        currentTrack: position.currentTrack,
                        currentSeek: position.currentSeek || 0,
                    });
                }
            }
        },
    });
}
